import { createAction } from 'typesafe-actions';

export const clearGeoAction = createAction('filters/geoCleared')();
